import type { SvgIconProps } from '../../types/props.ts'

export const CtvIconDark = (props: SvgIconProps) => {
  return (
    <svg
      {...props}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      role="img"
    >
      <path
        d="M0 5.99252C0 2.68294 2.9305 0 6.54545 0H41.4545C45.0695 0 48 2.68294 48 5.99252V42.0075C48 45.3171 45.0695 48 41.4545 48H6.54545C2.9305 48 0 45.3171 0 42.0075V5.99252Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M6.5459 0.5H41.4541C44.8352 0.5 47.4998 2.99952 47.5 5.99219V42.0078C47.4998 45.0005 44.8352 47.5 41.4541 47.5H6.5459C3.16476 47.5 0.500199 45.0005 0.5 42.0078V5.99219C0.500198 2.99952 3.16476 0.5 6.5459 0.5Z"
        stroke="white"
        strokeOpacity="0.1"
      />
      <path
        d="M12.5542 40.206V37.15C12.5542 36.398 12.1178 35.716 11.2778 35.716C10.4378 35.716 9.95345 36.398 9.95345 37.15V40.206H8.40872V34.488H9.83563L9.94909 35.184C10.2764 34.604 10.9964 34.396 11.5898 34.396C12.3338 34.396 13.08 34.674 13.4334 35.46C13.8559 34.7785 14.6634 34.3754 15.5171 34.42C17.2844 34.42 18.1549 35.42 18.1549 37.128V40.206H16.6145V37.128C16.6145 36.376 16.2742 35.728 15.4407 35.728C14.6073 35.728 14.0902 36.388 14.0902 37.14V40.196L12.5542 40.206Z"
        fill="white"
      />
      <path
        d="M24.5847 40.206V37.218C24.5847 36.35 24.0676 35.69 23.0836 35.69C22.1367 35.69 21.4931 36.42 21.4931 37.29V40.206H19.9658V34.488H21.3425L21.4429 35.264C22.0756 34.698 22.7062 34.408 23.4895 34.408C24.9535 34.408 26.1273 35.408 26.1273 37.208V40.208L24.5847 40.206Z"
        fill="white"
      />
      <path
        d="M29.9891 32.892V34.512H31.7062V35.728H29.976V38.192C29.976 38.736 30.3055 38.992 30.7855 38.992C31.0444 38.985 31.2985 38.9256 31.5295 38.818L31.9658 40.018C31.5611 40.1727 31.1279 40.2555 30.6895 40.262C29.3389 40.308 28.4553 39.602 28.4553 38.178V35.728H27.2946V34.512H28.4553V33.042L29.9891 32.892Z"
        fill="white"
      />
      <path
        d="M38.0814 40.206V37.218C38.0814 36.35 37.5622 35.69 36.5782 35.69C35.6313 35.69 34.9876 36.42 34.9876 37.29V40.206H33.4604V34.488H34.8349L34.9374 35.264C35.568 34.698 36.1985 34.408 36.9818 34.408C38.4458 34.408 39.6218 35.408 39.6218 37.208V40.208L38.0814 40.206Z"
        fill="white"
      />
      <path
        d="M23.6796 19.6868C23.6735 19.6804 23.669 19.6729 23.6665 19.6648C23.454 19.2973 23.2085 18.9461 22.9933 18.5797L16.5312 8.30681C16.4881 8.23257 16.4322 8.1652 16.3656 8.10734C16.0875 7.85124 15.7027 7.71684 15.3089 7.73831H10.0299C9.60422 7.73831 9.19603 7.89326 8.89524 8.16902C8.59446 8.44478 8.42577 8.81872 8.42634 9.20843V30.7835C8.41491 31.3356 8.78385 31.8347 9.34795 32.0302C9.84836 32.1886 10.4036 32.0725 10.7794 31.731L15.5137 27.3944C15.9393 27.0074 16.5871 26.9119 17.1238 27.157L23.0064 29.8539C23.5943 30.1226 24.3073 29.9798 24.7189 29.5108L27.7059 26.0899L23.6796 19.6868Z"
        fill="#1AC9AA"
      />
      <path
        d="M32.7105 7.7144C32.1426 7.71348 31.6182 7.99241 31.3379 8.44447C29.4228 11.5104 26.3442 16.6668 24.3659 19.6269C24.296 19.7387 24.1694 19.8107 24.0291 19.8188C23.8887 19.8268 23.7533 19.7697 23.6687 19.6668H23.6666L27.7059 26.0899L30.8302 22.4714C31.0761 22.1908 31.4409 22.0191 31.8333 21.9993C32.2257 21.9795 32.6088 22.1135 32.8869 22.3677L37.2117 26.3273C37.4097 26.5152 37.6647 26.6445 37.9438 26.6983C38.3487 26.7731 38.769 26.6775 39.0886 26.4378C39.4082 26.1981 39.5934 25.8398 39.593 25.4615V9.16856C39.593 8.78255 39.4254 8.41238 39.1271 8.13961C38.8287 7.86684 38.4242 7.71387 38.0026 7.7144H32.7105Z"
        fill="url(#paint0_linear_12079_15625)"
      />
      <path
        d="M23.6666 19.6648C23.6691 19.6729 23.6735 19.6804 23.6796 19.6867L27.7125 26.0898L23.6796 19.6867L23.6666 19.6648Z"
        fill="#1AC9AA"
      />
      <path
        d="M23.6666 19.6648C23.6691 19.6729 23.6735 19.6804 23.6796 19.6867L27.7125 26.0898L23.6796 19.6867L23.6666 19.6648Z"
        fill="url(#paint1_linear_12079_15625)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12079_15625"
          x1="26.9234"
          y1="31.2148"
          x2="43.5578"
          y2="26.6558"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#045562" />
          <stop offset="0.03" stopColor="#05606F" />
          <stop offset="0.1" stopColor="#06778A" />
          <stop offset="0.18" stopColor="#088BA0" />
          <stop offset="0.27" stopColor="#0999B1" />
          <stop offset="0.39" stopColor="#09A3BC" />
          <stop offset="0.55" stopColor="#0AA9C3" />
          <stop offset="1" stopColor="#0AABC5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12079_15625"
          x1="26.9989"
          y1="35.9675"
          x2="43.7275"
          y2="33.3773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#045562" />
          <stop offset="0.03" stopColor="#05606F" />
          <stop offset="0.1" stopColor="#06778A" />
          <stop offset="0.18" stopColor="#088BA0" />
          <stop offset="0.27" stopColor="#0999B1" />
          <stop offset="0.39" stopColor="#09A3BC" />
          <stop offset="0.55" stopColor="#0AA9C3" />
          <stop offset="1" stopColor="#0AABC5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
